export const page = {
	title: "Produtos",
	description: "Listagem e configuração de itens vendidos ao cliente final.",
	permissionError: "Você não possui as permissões",
	addProduct: "Adicionar produto",
	bulkImportProducts: "Importar produtos em massa",
	batchActions: "Ações em lote",
	exportAllProducts: "Exportar todos os produtos via Excel",
	editAllProducts: "Editar todos os produtos",
	downloadAllProducts: "Baixar tabela com todos os produtos",
};
